import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import { useTranslation } from 'react-i18next';
const CannotDeleteTAskAnswer = ({ title, message }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    return (_jsxs("div", { className: 'modal-content cannot-delete-task-answer', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: title, type: 'h1' }) }), message && _jsx("div", { className: "modal-content-description", children: message }), _jsx("div", { className: "modal-content-button", children: _jsx(Button, { label: t('button.ok'), onClick: () => {
                        dispatch(setIsModalOpen(false));
                        dispatch(setModalContent(null));
                    } }) })] }));
};
export default CannotDeleteTAskAnswer;
